import React from "react";
import ActionCard from "../../components/ActionCard";
import { useNavigate } from "react-router-dom";
import { FaClipboardCheck } from "react-icons/fa";

function CardProperty() {
  const navigate = useNavigate();

  const cards = [
    {
      description: "Agregar una nueva propiedad",
      icon: <FaClipboardCheck />,
      routePath: `agregar`,
      title: "Agregar propiedad",
    },
    {
      description: "Listado de todas las propiedades",
      icon: <FaClipboardCheck />,
      routePath: `ver`,
      title: "Ver propiedades",
    },
    {
      description: "Listado de todas las propiedades destacadas",
      icon: <FaClipboardCheck />,
      routePath: `destacadas`,
      title: "Propiedades destacadas",
    },
  ];

  const handleOnClickCard = (routePath) => {
    navigate(routePath);
  };

  return (
    <div className="flex flex-wrap justify-center w-full sm:justify-start ">
      {cards.map((card, index) => (
        <ActionCard
          description={card.description}
          icon={card.icon}
          key={index}
          title={card.title}
          onClick={() => handleOnClickCard(card.routePath)}
        />
      ))}
    </div>
  );
}

export default CardProperty;
